import {Events, type BroadcastEvent} from "./EventsBroadcastChannel.constants";
import type {EventHandlersMap} from "./EventsBroadcastChannel.types";

export const reloadPage = (): void => {
  globalThis.location.reload();
};

/** Обработчики других вкладок (вызываются из listen()). */
export const remoteHandlers: EventHandlersMap<BroadcastEvent> = {
  [Events.impersonate]: reloadPage,
  [Events.impersonateEnd]: reloadPage,
  [Events.logout]: reloadPage
};
